export default {
  settingWarehouse: {
    storehouse: '仓库',

    table: {
      storehouse: '仓库',
      logistics: '指定物流',
      logisticsBusiness: '指定物流业务',
      isExpressDelivery: '是否发货快递',
      returnExpress: '是否退货快递',
      priority: '优先级',
      updater: '更新人',
      lastUpdated: '最近更新时间'
    },

    addAndEdit: {
      editWarehouse: '编辑仓库配置',
      addWarehouse: '新建仓库配置',
      code: '仓库编码',
      selectWarehouse: '选择仓库',
      name: '仓库名称',
      warehouseText: '请选择仓库',
      logistics: '指定物流',
      business: '指定业务',
      logisticsText: '请先选择所属物流商',
      priority: '优先级',
      priorityText: '数值越小，优先级越高',
      express: '发货快递',
      returnExpress: '退货快递',
      selectLogistics: '请选择指定物流',
      selectBusiness: '请选择指定业务',
      selectPriority: '请输入优先级',
    }
  }
};
